module.exports = __webpack_public_path__ + "static/media/arrow-more.f55de0e2.svg";